const ROLE_NAMES_STORAGE_KEY = "roleNames";

export function getRoleNames(): string[] {
  const stored = localStorage.getItem(ROLE_NAMES_STORAGE_KEY);
  if (stored) {
    try {
      const parsed: unknown = JSON.parse(stored);
      if (Array.isArray(parsed)) {
        return parsed.filter((role): role is string => typeof role === "string" && role.length > 0);
      }
    } catch {
      // legacy fallback below
    }
  }

  const legacyRoleName = localStorage.getItem("roleName");
  return legacyRoleName ? [legacyRoleName] : [];
}

export function setRoleNames(roleNames: string[]): void {
  const unique = Array.from(new Set(roleNames.filter(Boolean)));
  localStorage.setItem(ROLE_NAMES_STORAGE_KEY, JSON.stringify(unique));
}

export function clearRoleNames(): void {
  localStorage.removeItem(ROLE_NAMES_STORAGE_KEY);
}

export function hasRole(roleName: string, roleNames: string[] = getRoleNames()): boolean {
  return roleNames.includes(roleName);
}

export function hasAnyRole(
  roleNamesToCheck: string[],
  roleNames: string[] = getRoleNames()
): boolean {
  return roleNamesToCheck.some((name) => roleNames.includes(name));
}

export function isAdmin(roleNames: string[] = getRoleNames()): boolean {
  return hasRole("ADMIN", roleNames);
}

/** Menü / route: rol listesinde veya (opsiyonel) yetkilerden en az biri var mı */
export function hasRoleOrPermission(
  allowedRoles: string[],
  permissions: string[] | undefined,
  permissionCheck: (permission: string) => boolean
): boolean {
  if (hasAnyRole(allowedRoles)) {
    return true;
  }
  if (!permissions?.length) {
    return false;
  }
  return permissions.some((permission) => permissionCheck(permission));
}
